"use client";

import React from "react";
import { Settings, Wrench, Maximize, TriangleAlert, ArrowRight, House, MapPin, Heart, ShieldCheck, BookOpen, Info, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "דף הבית",
  description: "חזרה לעמוד הראשי של Siudy – סיעוד מיידי. כאן תוכלו למצוא מידע מקיף על כל שירותי הסיעוד שלנו בפריסה ארצית והתחייבות להגעה תוך 5 שעות.",
  icon: House,
  link: "/HomePage"
}, {
  title: "מרכז רפואי איכילוב (סוראסקי)",
  description: "בית החולים המרכזי של תל אביב המציע שירותי רפואה דחופה, מחלקות אשפוז מתקדמות ומרכזי מצוינות בכל תחומי הכירורגיה והשיקום. אנו מספקים ליווי סיעודי צמוד.",
  icon: Settings,
  link: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
}, {
  title: "מטפל סיעודי בירושלים",
  description: "שירותי סיעוד דחופים בירושלים והסביבה. אנו מגיעים לכל בתי החולים בעיר (הדסה, שערי צדק) ולבתי המטופלים תוך פחות מ-5 שעות מרגע הפנייה.",
  icon: MapPin,
  link: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  title: "מטפל סיעודי בחיפה",
  description: "מענה סיעודי מהיר לתושבי חיפה והצפון. צוות המטפלים הישראלים שלנו זמין להגעה מיידית לרמב\"ם, בני ציון וכרמל למתן עזרה מקצועית.",
  icon: MapPin,
  link: "/NursingCareProviderInHaifaWithinHoursPage"
}, {
  title: "מטפל סיעודי בבית",
  description: "שירותי השגחה וטיפול סיעודי ברמת גן. פתרון אידיאלי למשפחות המחפשות מטפל ישראלי מוסמך לליווי בבית או בבית החולים תל השומר.",
  icon: Heart,
  link: "/NursingCareInRamatGanWithinHoursPage"
}, {
  title: "מטפל סיעודי פרטי",
  description: "שירות מותאם אישית לצרכי המטופל, הכולל ליווי צמוד בבדיקות רפואיות, עזרה בפעולות יומיומיות ותמיכה רגשית ברמה הגבוהה ביותר.",
  icon: ShieldCheck,
  link: "/NursingCareNowPage"
}, {
  title: "השגחה בבית חולים",
  description: "ליווי מקצועי של מטפל ישראלי במהלך אשפוז. אנו מבטיחים שהיקיר שלכם לעולם לא יישאר לבד, עם השגחה מלאה 24/7 במידת הצורך.",
  icon: Activity,
  link: "/CaregiverServicePagesPage"
}, {
  title: "זכויות סיעוד ביטוח לאומי",
  description: "מדריך מקיף על הזכויות המגיעות לכם מהמוסד לביטוח לאומי. למדו כיצד לממש את זכאותכם לקצבת סיעוד ושירותים נוספים.",
  icon: BookOpen,
  link: "/ProfessionalBlogPage"
}, {
  title: "איך לבחור מטפל סיעודי",
  description: "טיפים מעשיים לבחירת המטפל המתאים ביותר ליקירכם. מה חשוב לבדוק, אילו שאלות לשאול ואיך לוודא התאמה מקצועית ואישית.",
  icon: Info,
  link: "/BlogPage"
}, {
  title: "כמה עולה מטפל סיעודי",
  description: "סקירה של מחירי שירותי הסיעוד בישראל. הבנת העלויות השונות, אפשרויות המימון והסבסוד הממשלתי הזמין למשפחות.",
  icon: BookOpen,
  link: "/ProfessionalBlogPage"
}];
export default function RelatedServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260691" id="מיקומים-וביתנות-בתל-אביב" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`text-center mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 text-primary">
            מיקומים, שירותים ומאמרים מקצועיים
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            אנו מספקים מעטפת שלמה של שירותי סיעוד, מידע מקצועי וזמינות בפריסה ארצית רחבה לכל צורך רפואי או טיפולי.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full flex flex-col hover:shadow-xl transition-shadow duration-300 border-border bg-card rounded-lg shadow-md">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-lg bg-accent flex items-center justify-center mb-4">
                    <service.icon className="w-7 h-7 text-chart-3" />
                  </div>
                  <CardTitle className="text-2xl font-default text-card-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-default">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-0">
                  <Button asChild variant="outline" className="w-full sm:w-auto group border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                    <Link to={service.link}>
                      למידע נוסף
                      <ArrowRight className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform rotate-180" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}